import React, { type SelectHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { useGetCountryNames } from "src/shared/contacts/countries/useGetCountryNames";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { PleaseSelect } from "src/shared/forms/inputs/PleaseSelect";
import { required as Required } from "src/shared/forms/validations/Required";
import type { Country } from "src/shared/objects/Country";

export interface ICountryCodeInputProps
  extends IFormInputs,
    SelectHTMLAttributes<HTMLSelectElement> {
  countries: Country[];
}

export default (props: ICountryCodeInputProps) => {
  const {
    countries,
    inputID,
    label = <FormattedMessage id="contacts.country_code" />,
    ...rest
  } = props;
  const getCountryName = useGetCountryNames();
  return (
    <Field
      name={inputID}
      label={label}
      type="select"
      component={InputRenderer}
      validate={[Required]}
      {...rest}
    >
      <PleaseSelect />
      {countries.map((country) => (
        <option key={country.countryCode} value={country.countryCode}>
          {getCountryName(country)}
        </option>
      ))}
    </Field>
  );
};
